import React from "react";

import { FormControl } from "react-bootstrap";

import FsInput from "./FsInput";

export default class FsTextArea extends FsInput {
  renderInput() {
    const { formState, attribute, name, placeholder, disabled } = this.props;

    return (
      <FormControl
        componentClass="textarea"
        name={name || attribute}
        value={formState.readFormAttribute(attribute)}
        onChange={this.update.bind(this)}
        placeholder={placeholder}
        disabled={disabled}
      />
    );
  }
}
